import styled, { css } from 'styled-components';

export const CheckboxToggleCount = styled.div<{ countOnTheLeft?: boolean }>`
  margin-right: 8px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  ${({ countOnTheLeft }) =>
    countOnTheLeft
      ? css`
          margin-left: 8px;
        `
      : css`
          margin-left: auto;
        `}
`;
